require('./bootstrap')

// window.Vue = require('vue');
import Vue from 'vue'
import VueRouter from 'vue-router'
import router from "./routes/frontend";
import store from './store';
import VueLazyload from 'vue-lazyload'
import axios from 'axios'
import VueAxios from 'vue-axios'
import CoolLightBox from 'vue-cool-lightbox'
import vSelect from 'vue-select';
import VuePlyr from 'vue-plyr';
import ProductZoomer from 'vue-product-zoomer';
import helper from './helper'
import objectToFormData from "./objectToFormData";
import VueProgressBar from 'vue-progressbar'
import Vue2Filters from 'vue2-filters';
import { initializeApp } from "firebase/app";
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'
import './eventBus.js'

Vue.use(VueRouter);
Vue.use(CoolLightBox);
Vue.use(VueAxios, axios)
Vue.use(ProductZoomer);
Vue.component('v-select', vSelect);
Vue.use(VuePlyr, {
    plyr: {}
})

Vue.use(VueLazyload)
Vue.config.productionTip = true;

if (process.env.APP_ENV !== 'production') {
    Vue.config.devtools = true;
    Vue.config.productionTip = false;
  }

window.objectToFormData = objectToFormData;

Vue.component('frontend_master', require('./components/frontend/frontend_master').default);
Vue.component('loading_button', require('./components/frontend/partials/loading_button').default);

const options = {
    color: 'var(--primary-color)',
    failedColor: '#bb2d3b',
    thickness: '2px',
    transition: {
        speed: '0.2s',
        opacity: '0.6s',
        termination: 300
    },
    autoRevert: true,
    location: 'top',
    inverse: false
}

Vue.use(VueProgressBar, options);
Vue.use(Vue2Filters);

function getValueFromId(id)
{
    let value = '';
    let input_box = document.getElementById(id);

    if (input_box)
    {
        value = input_box.value;
    }
    return value;
}

// const firebaseConfig = {
//     apiKey: getValueFromId('api_key'),
//     authDomain: getValueFromId('auth_domain'),
//     projectId: getValueFromId('project_id'),
//     storageBucket: getValueFromId('storage_bucket'),
//     messagingSenderId: getValueFromId('messaging_sender_id'),
//     appId: getValueFromId('app_id'),
//     measurementId: getValueFromId('measurement_id')
// };

// Initialize Firebase
/// const firebase_app = initializeApp(firebaseConfig);

router.base= app_path

let sessionValidated = false; // Variable global para verificar si la sesión ya fue validada

// Ejecuta la validación solo una vez cuando se recarga la página
if (!sessionValidated) {
    sessionValidated = true

    router.onReady(() => {
        const isAuthenticated = typeof(store.state.storeData?.user) !== 'undefined' && Object.keys(store.state.storeData?.user).length > 0
        console.log('isAuthenticated:', isAuthenticated)

        if (!isAuthenticated && router.currentRoute.meta.requiresAuth) {
            router.replace('/login')
        }
    })
}

const app = new Vue({
    el: '#app',
    router,
    mixins: [helper],
    store,
}).$mount('#app');

export default store

